<template>
    <div>
        <el-dialog title="配煤记录详情" style="text-align:center" :visible="visible" :show="show" width="75%"      @close="close" :close-on-click-modal="false">
            <span v-if="this.rowData.matchType=='系统配煤'" style="color:red;margin-bottom:10px">1-2种为系统最优解，3-5种分别取最优各煤源和其他煤源搭配的结果，6-7种取非1-2种的配煤结果，需破碎煤源会自动降热值</span>
            <span v-if="this.rowData.matchType=='自建库配煤'" style="color:red;margin-bottom:10px">除自选煤源外，1-2种为系统最优解，3-5种分别取最优各煤源和其他煤源搭配的结果，6-7种取非1-2种的配煤结果，需破碎煤源会自动降热值</span>

            <el-table :data="dataList" border style="width: 100%" height="500px">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column label="煤源1/占比/热值/到场地" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.cocalId1!==0" @click="openCocalDetail(scope.row.cocalId1,1,scope.row.isOwner1)" style="color:blue;cursor:pointer"> {{scope.row.cocalName1}}/{{scope.row.weight1}}%/{{scope.row.hots1}}/{{scope.row.arriveStation1}} </span>
                        <span v-else>未参与配煤</span>
                        
                    </template>
                </el-table-column>
                <el-table-column label="煤源2/占比/热值/到场地" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.cocalId2!==0" @click="openCocalDetail(scope.row.cocalId2,2,scope.row.isOwner2)" style="color:blue;cursor:pointer"> {{scope.row.cocalName2}}/{{scope.row.weight2}}%/{{scope.row.hots2}}/{{scope.row.arriveStation2}}</span>
                        <span v-else>未参与配煤</span>
                    </template>
                </el-table-column>
                <el-table-column label="煤源3/占比/热值/到场地" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.cocalId3!==0" @click="openCocalDetail(scope.row.cocalId3,3,scope.row.isOwner3)" style="color:blue;cursor:pointer"> {{scope.row.cocalName3}}/{{scope.row.weight3}}%/{{scope.row.hots3}}/{{scope.row.arriveStation3}}</span>
                        <span v-else>未参与配煤</span>
                    </template>
                </el-table-column>
                <el-table-column label="煤源4/占比/热值/到场地" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.cocalId4!==0" @click="openCocalDetail(scope.row.cocalId4,4,scope.row.isOwner4)" style="color:blue;cursor:pointer"> {{scope.row.cocalName4}}/{{scope.row.weight4}}%/{{scope.row.hots4}}/{{scope.row.arriveStation4}}</span>
                        <span v-else>未参与配煤</span>
                    </template>
                </el-table-column>
                <el-table-column label="煤源5/占比/热值/到场地" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.cocalId5!==0" @click="openCocalDetail(scope.row.cocalId5,5,scope.row.isOwner5)" style="color:blue;cursor:pointer"> {{scope.row.cocalName5}}/{{scope.row.weight5}}%/{{scope.row.hots5}}/{{scope.row.arriveStation5}}</span>
                        <span v-else>未参与配煤</span>
                    </template>
                </el-table-column>
                <el-table-column label="配煤热值" align="center" width="80" prop="matchHots"></el-table-column>
                <el-table-column label="配煤硫分值" align="center" width="80" prop="matchLiufen"></el-table-column>
                <el-table-column label="配煤价格" align="center" width="80" prop="matchPrice"></el-table-column>
                <el-table-column label="优先级" align="center" width="80" prop="sort"></el-table-column>
            </el-table>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-dialog>
        <!--煤源煤炭明细页面-->
        <el-dialog title="煤种数据" style="text-align:center" :visible="cocalDetailVisible" :show="show" width="70%" :close-on-click-modal="false"
                   @close="cocalDetailVisible=false">
            <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" label-width="140px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="煤矿名称" class="input" prop="cocalName" >
                            <el-input v-model="ruleForm.cocalName" autocomplete="off" placeholder="煤炭名称" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="联系人" class="input" prop="personName" >
                            <el-input v-model="ruleForm.personName" autocomplete="off" placeholder="联系人" />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="联系电话" class="input" prop="mobile" >
                            <el-input v-model="ruleForm.mobile" autocomplete="off" placeholder="联系电话" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="煤种类型" class="input" prop="cocalType" >
                            <el-input v-model="ruleForm.cocalType" autocomplete="off" placeholder="煤种类型" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="硫分" class="input" prop="liufen" >
                            <el-input v-model="ruleForm.liufen" autocomplete="off" placeholder="硫分" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="热值" class="input" prop="hots" >
                            <el-input v-model="ruleForm.hots" autocomplete="off" placeholder="热值" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否破碎" class="input" prop="isBroken" >
                            <el-select v-model="ruleForm.isBroken" style="width:80%">
                                <el-option label="是" value="是"></el-option>
                                <el-option label="否" value="否"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="破碎费用" class="input" prop="brokenPrice" >
                            <el-input v-model="ruleForm.brokenPrice" autocomplete="off" placeholder="破碎费用" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="全水" class="input" prop="quanshui" >
                            <el-input v-model="ruleForm.quanshui" autocomplete="off" placeholder="全水" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="收到基灰分" class="input" prop="sdjhScore" >
                            <el-input v-model="ruleForm.sdjhScore" autocomplete="off" placeholder="收到基灰分" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="焦渣特征" class="input" prop="jztz" >
                            <el-input v-model="ruleForm.jztz" autocomplete="off" placeholder="焦渣特征" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="空气干燥基固定碳" class="input" prop="kqgzjgdt" >
                            <el-input v-model="ruleForm.kqgzjgdt" autocomplete="off" placeholder="空气干燥基固定碳" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="空气干燥基挥发分" class="input" prop="kqgzjhfScore" >
                            <el-input v-model="ruleForm.kqgzjhfScore" autocomplete="off" placeholder="空气干燥基挥发分" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="含税单价" class="input" prop="unitPrice" >
                            <el-input v-model="ruleForm.unitPrice" autocomplete="off" placeholder="含税单价" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="库存" class="input" prop="stock" >
                            <el-input v-model="ruleForm.stock" autocomplete="off" placeholder="库存" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="到场地" class="input" prop="arriveStation" >
                            <el-input v-model="ruleForm.arriveStation" autocomplete="off" placeholder="到场地" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="含税运费" class="input" prop="hsPrice" >
                            <el-input v-model="ruleForm.hsPrice" autocomplete="off" placeholder="含税运费" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="场地费" class="input" prop="stationPrice" >
                            <el-input v-model="ruleForm.stationPrice" autocomplete="off" placeholder="场地费" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if=" orgType!='3'">
                    <el-col :span="6">
                        <el-form-item label="煤炭成本" class="input" prop="cocalCost" >
                            <el-input v-model.number="ruleForm.cocalCost" autocomplete="off" placeholder="煤炭成本"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="单卡价" class="input" prop="cocalPrice" >
                            <el-input v-model.number="ruleForm.cocalPrice" autocomplete="off" placeholder="单卡价"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="平板价" class="input" prop="sweepPrice" >
                            <el-input v-model.number="ruleForm.sweepPrice" autocomplete="off" placeholder="平板价"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="平仓价" class="input" prop="pingcangPrice" >
                            <el-input v-model.number="ruleForm.pingcangPrice" autocomplete="off" placeholder="平仓价"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                    <el-button class="btn close" @click="cocalDetailVisible=false">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    export default{
        name:'portCocalMatchList',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                }
            },
            rowData(){
                if (this.show){
                    this.getCocalMatchList();
                }
            },
        },
        data(){
            return{
                visible:false,
                dataList:[],
                cocalDetailVisible:false,
                ruleForm:{},
            }
        },
        methods:{
            close(){
                this.dataList = [];
                this.$emit("listenToChildEvent",false);
            },
            getCocalMatchList(){
                this.$http({
                    url: "portMatchResult/info/"+this.rowData.id,
                    method: "get",
                }).then(({data}) => {
                    this.dataList = data.detailList;
                });
            },
            openCocalDetail(id,index,isOwner){
                this.ruleForm = {};
                if (!isOwner){
                    this.$http({
                        url: "cocalTemplate/info/"+id,
                        method: "get",
                    }).then(({data}) => {
                        this.ruleForm = data.data;
                        this.cocalDetailVisible = true;
                    });
                }else{
                    this.$http({
                        url: "cocalTemplateOwner/info/"+id,
                        method: "get",
                    }).then(({data}) => {
                        this.ruleForm = data.data;
                        this.cocalDetailVisible = true;
                    });
                }

            }


        }
    }
</script>